import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';
import FlattenerHero from './components/FlattenerHero';
import FlattenerFeatures from './components/FlattenerFeatures';
import FlattenerBenefits from './components/FlattenerBenefits';
import FlattenerPricing from './components/FlattenerPricing';
import FlattenerCTA from './components/FlattenerCTA';

export default function PDFFormsFlattenerPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    document.title = 'PDF Forms Flattener - 专业PDF表单扁平化工具 | 星允信息';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'PDF Forms Flattener是专业的命令行工具，支持AcroForm、静态XFA和动态XFA表单扁平化处理，自动生成外观流，支持JavaScript执行，确保文档在所有PDF查看器中一致显示。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'PDF表单扁平化,XFA表单处理,AcroForm转换,PDF Forms Flattener,表单数据导出,PDF命令行工具');
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/pdf-forms-flattener`);

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "PDF Forms Flattener",
      "description": "专业的PDF表单扁平化命令行工具，支持AcroForm、静态XFA和动态XFA表单处理",
      "url": `${siteUrl}/pdf-forms-flattener`,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Windows, Linux",
      "offers": {
        "@type": "Offer",
        "price": "2999",
        "priceCurrency": "CNY",
        "availability": "https://schema.org/InStock",
        "priceValidUntil": "2025-12-31"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "45"
      },
      "featureList": [
        "表单扁平化处理",
        "外观流自动生成",
        "JavaScript支持",
        "XFA转AcroForm",
        "表单数据导入导出",
        "打印和屏幕优化"
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <FlattenerHero />
        <FlattenerFeatures />
        <FlattenerBenefits />
        <FlattenerPricing />
        <FlattenerCTA />
      </main>
      <Footer />
    </div>
  );
}
